import React from 'react';
import { Path } from 'app/const/Path';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { WebshopButton } from 'app/modules/web-shop/components/buttons';
import {
  landingHeaderCss,
  landingContentCss,
  landingHeaderImg,
  bottomRightOrnamentCss,
  containerCss,
  dotsOrnamentCss,
  gotoLinksCss,
  leftTopOrnamentCss,
} from 'app/modules/web-shop/sub-modules/landing-module/components/landing-header/style';
import { ReactComponent as DotsOrnament } from 'app/modules/web-shop/components/ornaments/Dots.svg';
import { ReactComponent as LandingHeaderImg } from 'app/modules/web-shop/sub-modules/landing-module/components/landing-header/assets/LandingHeaderImg.svg';
import { ReactComponent as LeftTopOrnament } from 'app/modules/web-shop/sub-modules/landing-module/components/landing-header/assets/Left-top-corner-ornament.svg';
import { ReactComponent as BottomRightOrnament } from 'app/modules/web-shop/sub-modules/landing-module/components/landing-header/assets/right-bottom-corner-ornament.svg';
import HEAD from 'app/components/SeoHelmet';

export function LandingHeader() {
  return (
    <>
      <HEAD
        description="Built for aid professionals active in the aid chain and who need access to aid data for data management, exploration, analysis and visualisation"
        title="Maximize Your Impact with
        a Results-Oriented Open 
        Data Solution"
        name="AIDA"
        type="website"
      />

      <Box css={landingHeaderCss}>
        <LeftTopOrnament css={leftTopOrnamentCss} />
        <Container maxWidth="lg" css={containerCss}>
          <Grid container css={landingContentCss}>
            <Grid item xs={12} sm={9} md={7} lg={8}>
              <h1>
                Maximize Your Impact with <br /> a Results-Oriented Open <br />{' '}
                Data Solution
              </h1>

              <p>
                Designed for aid professionals seeking to work with{' '}
                <b>IATI data</b>, the AIDA Platform is the ultimate solution for
                all your needs - from publishing open aid data, managing
                information, uncovering new insights, analyzing data, to
                visualizing trends.
              </p>

              <div css={gotoLinksCss}>
                <Link to={Path.webshop.plans}>
                  <WebshopButton text="see plans" />
                </Link>

                <Link to={Path.home}>
                  <WebshopButton text="Start Exploring" />
                </Link>
              </div>
            </Grid>

            <Grid item xs={12} sm={3} md={5} lg={4} css={landingHeaderImg}>
              <LandingHeaderImg />
            </Grid>
          </Grid>

          <BottomRightOrnament css={bottomRightOrnamentCss} />
          <DotsOrnament css={dotsOrnamentCss} />
        </Container>
      </Box>
    </>
  );
}
